import { createUseFilter } from '@atlassian/jira-directory-base-v3/src/controllers/create-use-filter/index.tsx';
import { matchAliases } from '@atlassian/jira-directory-base-v3/src/utils/search-string/index.tsx';
import {
	filterInitialState,
	filterAliasMap,
	type FilterInitialState,
} from '@atlassian/jira-projects-directory-v3-utils/src/constants.tsx';
import { sanitizeLegacyQuery } from '@atlassian/jira-projects-directory-v3-utils/src/utils/index.tsx';

const { useScopedFilter, useFilter, FilterContainer } = createUseFilter<FilterInitialState>(
	'ProjectsDirectoryFilterState',
	{
		getInitialState: ({ routeQuery }) =>
			matchAliases(filterInitialState, sanitizeLegacyQuery(routeQuery), filterAliasMap),
	},
);

export type UseScopedFilter = typeof useScopedFilter;
export { useScopedFilter, useFilter, FilterContainer };
